import React from 'react';
import {Field} from 'redux-form';
import SelectField from '../../../../../shared/form-elements/select/field';
import Input from '../../../../../shared/form-elements/input';
import {formatMoney} from '../../../../../shared/format';

const Form = props => (
	<div className="payouts-form__main-fields">
		<div className="affiliates display-flex width-100-p">
			<div className="ui-form__element width-50-p padding-0-5-0-0">
				<Field
					name="affiliate"
					placeholder={props.intl('Affiliate')}
					component={Input}
					multi={false}
					disabled={true}
				/>
			</div>
			<div className="ui-form__element comment width-50-p">
				<Field
					name="exchange_rate"
					onChange={(e) => props.changeDefaultComment({
						exchange_rate: e.target.value
					})}
					placeholder={props.intl('Exchange rate:')}
					component={Input}
				/>
			</div>
		</div>
		<div className="affiliates display-flex width-100-p">
			<div className="ui-form__element amount width-50-p padding-0-5-0-0">
				<Field
					name="amount"
					placeholder={props.intl('Source amount')}
					normalize={value => formatMoney(value, true)}
					component={Input}
				/>
			</div>
			<div className="ui-form__element currencies">
				<Field
					name="source_currency"
					placeholder={props.intl('Source currency')}
					component={SelectField}
					searchable={false}
					multi={false}
					onChange={ () => setTimeout(props.fetchExchangeRate, 1500)}
					options={props.selectOptions['currencies']}
				/>
			</div>
			<div className="ui-form__element currencies margin-0-15">
				<Field
					name="target_currency"
					placeholder={props.intl('Target currency')}
					component={SelectField}
					searchable={false}
					multi={false}
					onChange={ () => setTimeout(props.fetchExchangeRate, 1500)}
					options={props.selectOptions['currencies']}
				/>
			</div>
		</div>
		<div className="ui-form__element comment">
			<Field name="comment" placeholder={props.intl('Comment')} component={Input} />
		</div>
	</div>
);

export default Form;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/forms/transaction/forms-parts/currencyExchange.js